import { c as _c } from "react/compiler-runtime";
/**
 * useMarketDetailPrefetchIntent — canonical hover/focus/touch intent triple
 * for any element that navigates to a market detail page
 * (`/markets/[pubkey]`).
 *
 * Wraps `usePrefetchGetMarket` + `useIntentPrefetch` so intent warms the fixed
 * detail DTO cache entry consumed by the destination `useGetMarket` call.
 *
 * Chart prefetch (which only the discover-feed market card currently
 * warms — see `market-row-card.tsx`) is intentionally OUT of scope here.
 * That surface has access to the row's `outcomeCount` + `createdAt` which
 * are not available on every callsite (portfolio rows, thesis cards,
 * activity rows), and warming charts without those args produces a
 * cache-key mismatch. A future `useMarketDetailWithChartPrefetchIntent`
 * helper can layer this on for callsites that have the chart args.
 *
 * No-ops when `pubkey` is null or empty.
 */

import { type IntentHandlers, useIntentPrefetch, usePrefetchGetMarket } from '@morfi/backend-sdk-v2/client';
export function useMarketDetailPrefetchIntent(pubkey) {
  const $ = _c(3);
  const prefetchMarket = usePrefetchGetMarket();
  let t0;
  if ($[0] !== prefetchMarket || $[1] !== pubkey) {
    t0 = () => {
      if (pubkey === null || pubkey.length === 0) {
        return;
      }
      prefetchMarket({
        pubkey
      });
    };
    $[0] = prefetchMarket;
    $[1] = pubkey;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useIntentPrefetch(t0);
}